
import React from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { useState, useEffect } from 'react';
import { MenuItem } from "@mui/material";
import Select from "@mui/material/Select";
import FormControl from '@mui/material/FormControl';
import DialogActions from '@mui/material/DialogActions';


import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Checkbox from '@mui/material/Checkbox';
import { ToastContainer, toast } from 'react-toastify';
import axios from '../../../../utils/fvAxios';


export default function SetupNotificationsEditandAdd({ INFO, CLIENTID, ID, CLOSE, SETUPID, RESETDATA, RESET, DATA, DOCLIST, PQLIST }) {
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: 50 * 5 + 8,
                width: 200,
            },
        },
    };
    const toastNotify = (message, isSuccess = true) => {
        if (isSuccess) {
            toast.success(message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        } else {
            toast.error(message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    };


    const [setupType, setSetupType] = useState(ID == 1 ? "0" : DATA?.setupType);
    const [name, setName] = useState(ID == 1 ? "" : DATA?.setupTypeId);
    const [FNotification, setFNotification] = useState(ID == 1 ? "" : DATA?.firstNotification);
    const [SNotification, setSNotification] = useState(ID == 1 ? "" : DATA?.secondNotification);
    const [TNotification, setTNotification] = useState(ID == 1 ? "" : DATA?.thirdNotification);
    const [emailTemplate, setEmailTemplate] = useState(ID == 1 ? "0" : DATA?.emailTemplateType);
    const [SendNotifocation, setSendNotifocation] = React.useState("");

    const [Dis, setDis] = React.useState(false);

    useEffect(() => {
        Details();
        setSendNotifocation(ID == 1 ? "" : DATA?.sendNotificationTo);
    }, []);

    const [OrgUsers, setOrgUsers] = React.useState([]);
    const [EmailList, setEmailList] = React.useState([]);

    const [orgUserId, setOrgUserId] = React.useState("");
    const [emailId, setEmailId] = React.useState(ID == 1 ? "" : DATA?.emailTemplateID?.toString());

    const [currentNotification, setCurrentNotification] = React.useState({});

    async function Details() {
        // if (ID != 1) {
        const val = ID == 1 ? -1 : DATA?.orgEmailSetupId;
        const Cli = ID == 1 ? CLIENTID : DATA?.organizationId;
        const res = await axios.get("EmailSetupNotifications/GetDetailsToAddOrUpdateEmailSetupNotification?orgId=" + Cli + "&orgEmailSetUpId=" + val);
        setOrgUsers(res?.data?.data?.sysUserOrg_Users);
        setEmailList(res?.data?.data?.emailTemplates);
        setCurrentNotification(res?.data?.data?.currentNotification);
        setOrgUserId(ID == 1 ? "" : res?.data?.data?.currentNotification?.primaryUserId);
        // }
    }



    const [FError, setFError] = useState("");
    const [SError, setSError] = useState("");
    const [TError, setTError] = useState("");

    const ChangeNotification = (ans) => {
        setSNotification("");
        if (ans?.length < 3) {
            if (ans < 100 && ans >= 1) {
                setFNotification(ans);
                setFError("");
                setSError("");
            } else if (ans == "" || ans == 0) {
                setFNotification("");
                setSNotification("");
                setTNotification("");
                setFError("");
                setSError("");
                setTError("");
            } else {
                setFNotification("");
                setFError("Number of days should be less than 100 days");
            }
        } else {
            setFNotification("");
            setFError("Number of days should be less than 100 days");
        }
    };
    const ChangeNotification2 = (ans) => {
        setTNotification("");
        if (Number(FNotification) != "") {
            if (ans?.length < 3) {
                if (ans < 100 && ans >= 1) {
                    if (Number(FNotification) > Number(ans)) {
                        setSNotification(ans);
                        setSError("");
                        setTError("");
                    } else if (ans == "" || ans == 0) {
                        setSNotification(ans);
                        setTNotification("");
                        setSError("");
                        setTError("");
                    } else {
                        setSNotification(ans);
                        setSError("Second Notification should be less than first notification");
                    }
                } else if (ans == "") {
                    setSNotification("");
                    setTNotification("");
                    setSError("");
                    setTError("");
                } else {
                    setSNotification("");
                    setSError("Number of days should be less than 100 days");
                }
            } else {
                setSNotification("");
                setSError("Number of days should be less than 100 days");
            }
        } else {
            setSNotification("");
            setSError("Please Enter First notification");
        }
    };
    const ChangeNotification3 = (ans) => {
        if (Number(SNotification) != "") {
            if (ans?.length < 3) {
                if (ans < 100 && ans >= 1) {
                    if (Number(SNotification) > Number(ans)) {
                        setTNotification(ans);
                        setTError("");
                    } else if (ans == "" || ans == 0) {
                        setTNotification(ans);
                        setTError("");
                    } else {
                        setTNotification(ans);
                        setTError("Third Notification should be less than second notification");
                    }
                } else if (ans == "") {
                    setTNotification("");
                    setTError("");

                } else {
                    setTNotification("");
                    setTError("Number of days should be less than 100 days");
                }
            } else {
                setTNotification("");
                setTError("Number of days should be less than 100 days");
            }
        } else {
            setTNotification("");
            setTError("Please Enter Second notification");
        }

    };


    const SendNotificationTo = (val, ans) => {
        if (val == false) {
            setSendNotifocation(SendNotifocation.replace(ans + ",", ""));
        } else {
            setSendNotifocation(SendNotifocation + ans + ",");
        }
    }

    const SaveorDeleteNotifications = async () => {
        setDis(true);
        if (ID == 1 || ID == 2) {

            if (setupType != 3 && name != "") {
                const data = {
                    "organizationId": CLIENTID,
                    "setupType": setupType,
                    "setupTypeId": setupType == 3 ? null : name?.toString(),
                    "firstNotification": FNotification,
                    "secondNotification": SNotification == "" ? null : SNotification,
                    "thirdNotification": TNotification == "" ? null : TNotification,
                    "sendNotificationToClient": SendNotifocation.includes("Client") ? true : false,
                    "sendNotificationToVendor": setupType == 3 ? SendNotifocation.includes("Vendor") ? true : false : true,
                    "sendNotificationToFirstVerify": SendNotifocation.includes("First Verify") ? true : false,
                    "sendNotificationToSiteContacts": SendNotifocation.includes("Site Contacts") ? true : false,
                    "isInsert": ID == 1 ? true : currentNotification?.isInsert,
                    "primaryUserId": SendNotifocation.includes("Client") ? orgUserId : null,
                    "orgEmailSetupId": ID == 1 ? -1 : currentNotification?.orgEmailSetupId,
                    "emailTemplateType": emailTemplate,
                    "emailTemplateID": emailTemplate == 0 ? null : emailId,
                }
                const res = await axios.post("EmailSetupNotifications/AddOrUpdateEmailSetupNotification", data);
                if (res?.data?.responseCode == 100) {
                    setTimeout(() => {
                        CLOSE();
                    }, 500);
                    //setDis(false);
                    toastNotify(res?.data?.data, true);

                } else {
                    toastNotify(res?.data?.responseMessage, false);
                    //setDis(false);
                }

            } else if (setupType == 3) {
                const data = {
                    "organizationId": CLIENTID,
                    "setupType": setupType,
                    "setupTypeId": setupType == 3 ? null : name?.toString(),
                    "firstNotification": FNotification,
                    "secondNotification": SNotification == "" ? null : SNotification,
                    "thirdNotification": TNotification == "" ? null : TNotification,
                    "sendNotificationToClient": SendNotifocation.includes("Client") ? true : false,
                    "sendNotificationToVendor": setupType == 3 ? SendNotifocation.includes("Vendor") ? true : false : true,
                    "sendNotificationToFirstVerify": SendNotifocation.includes("First Verify") ? true : false,
                    "sendNotificationToSiteContacts": SendNotifocation.includes("Site Contacts") ? true : false,
                    "isInsert": ID == 1 ? true : currentNotification?.isInsert,
                    "primaryUserId": SendNotifocation.includes("Client") ? orgUserId : null,
                    "orgEmailSetupId": ID == 1 ? -1 : currentNotification?.orgEmailSetupId,
                    "emailTemplateType": emailTemplate,
                    "emailTemplateID": emailTemplate == 0 ? null : emailId,
                }
                const res = await axios.post("EmailSetupNotifications/AddOrUpdateEmailSetupNotification", data);
                if (res?.data?.responseCode == 100) {
                    setTimeout(() => {
                        CLOSE();
                    }, 500);
                    //setDis(false);
                    toastNotify(res?.data?.data, true);
                } else {
                    toastNotify(res?.data?.responseMessage, false);
                    //setDis(false);
                }
            }
            else {
                toastNotify("Please enter the mandatory fields", false);
                //setDis(false);
            }

        } else if (ID == 3) {
            const resp = await axios.post("EmailSetupNotifications/DeleteEmailSetupNotification?OrgEmailSetupId=" + SETUPID);
            if (resp?.data?.responseCode == 100) {
                setTimeout(() => {
                    CLOSE();
                }, 500);
                //setDis(false);
                toastNotify(resp?.data?.responseMessage, true);
            } else {
                toastNotify(resp?.data?.responseMessage, false);
                //setDis(false);
            }

        }
        setTimeout(() => {
            INFO(CLIENTID);
            setDis(false);
        }, 500);

    }


    return (

        <div>
            <ToastContainer />
            {ID == 3 ? "Are you sure do you want to delete this notification?"
                :
                <div>
                    <div >
                        <span style={{ color: "#3E4A62", fontSize: "20px" }}>Setup Type </span>
                        <br />

                        <FormControl>
                            <RadioGroup
                                aria-labelledby="demo-radio-buttons-group-label"
                                defaultValue="Document Type"
                                name="radio-buttons-group"
                                value={setupType}
                                onChange={(event) => setSetupType(event.target.value)}
                            >

                                <FormControlLabel value={0} control={<Radio />} label="Document Type" />
                                <FormControlLabel value={1} control={<Radio />} label="Prequalification Period Expiration" />
                                <FormControlLabel value={3} control={<Radio />} label="Contractor Evaluation Period Expiration" />

                            </RadioGroup>
                        </FormControl>

                    </div>

                    <div className='mt-2' hidden={setupType == 3}>
                        <span style={{ color: "#3E4A62", fontSize: "20px" }}> Name <span style={{ color: "red" }}>*</span></span>
                        <br />
                        <Select
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                                width: "320px"
                            }}
                            labelId="demo-multiple-name-label"
                            id="demo-multiple-name"
                            size="small"
                            value={name || ""}
                            onChange={(e) => setName(e.target.value)}
                            MenuProps={MenuProps}
                        >
                            {setupType == 0 && setupType != 3 ?
                                DOCLIST?.map((r, i) =>
                                    <MenuItem key={i} title={r?.documentTypeName} value={r?.documentTypeId}>{r?.documentTypeName}</MenuItem>)
                                :
                                PQLIST?.map((p, i) =>
                                    <MenuItem key={i} title={p?.prequalificationStatusName} value={p?.prequalificationStatusId}>{p?.prequalificationStatusName}</MenuItem>)
                            }

                        </Select>

                    </div>
                    <div className='mt-2'>
                        <span style={{ color: "#3E4A62", fontSize: "20px" }}>First Notification (Days)  <span style={{ color: "red" }}>*</span></span>
                        <br />

                        <TextField
                            placeholder=''
                            type='number'
                            InputProps={{ inputProps: { min: "1", max: "99" } }}
                            sx={{
                                "& legend": { display: "none" },
                                "& fieldset": { top: 0 },
                                fontFamily: "Arial, FontAwesome",
                                width: "320px"
                            }}
                            variant="outlined"
                            size="small"
                            value={FNotification}
                            onChange={(e) => ChangeNotification(e.target.value)}
                        />
                        <br />
                    </div>
                    <div style={{ width: "320px" }}>
                        <span style={{ color: "red" }}>{FError}</span>
                    </div>


                    <div className='mt-2' >
                        <span style={{ color: "#3E4A62", fontSize: "20px" }}>Second Notification (Days) </span>
                        <br />

                        <TextField
                            placeholder=''
                            type='number'
                            InputProps={{ inputProps: { min: "1", max: "29" } }}
                            sx={{
                                "& legend": { display: "none" },
                                "& fieldset": { top: 0 },
                                fontFamily: "Arial, FontAwesome",
                                width: "320px"
                            }}
                            variant="outlined"
                            size="small"
                            value={SNotification}
                            onChange={(e) => ChangeNotification2(e.target.value)}
                        />
                        <br />
                    </div>
                    <div style={{ width: "320px" }}>
                        <span style={{ color: "red" }}>{SError}</span>
                    </div>


                    <div className='mt-2'>
                        <span style={{ color: "#3E4A62", fontSize: "20px" }}>Third Notification (Days) </span>
                        <br />

                        <TextField
                            placeholder=''
                            type='number'
                            InputProps={{ inputProps: { min: "1", max: "29" } }}
                            sx={{
                                "& legend": { display: "none" },
                                "& fieldset": { top: 0 },
                                fontFamily: "Arial, FontAwesome",
                                width: "320px"
                            }}
                            variant="outlined"
                            size="small"
                            value={TNotification}
                            onChange={(e) => ChangeNotification3(e.target.value)}
                        />
                        <br />
                    </div>
                    <div style={{ width: "320px" }}>
                        <span style={{ color: "red" }}>{TError}</span>
                    </div>


                    <div className='mt-2' hidden={SendNotifocation.includes("Client") ? false : true}>
                        <span style={{ color: "#3E4A62", fontSize: "20px" }}>Pimary User  <span style={{ color: "red" }}>*</span></span>
                        <br />
                        <Select
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                                width: "320px"
                            }}
                            labelId="demo-multiple-name-label"
                            id="demo-multiple-name"
                            size="small"
                            value={orgUserId || ""}
                            onChange={(e) => setOrgUserId(e.target.value)}
                            MenuProps={MenuProps}
                        >
                            {OrgUsers?.map((r, i) =>
                                <MenuItem key={i} title={r?.text} value={r?.value}>{r?.text}</MenuItem>)}
                        </Select>

                    </div>
                    <div className='mt-2'>
                        <span style={{ color: "#3E4A62", fontSize: "20px" }}>Send Notification To </span>
                        <br />
                        <FormControl sx={{ marginLeft: "10px" }}>
                            <FormControlLabel value={"First Verify"} control={<Checkbox checked={SendNotifocation.includes("First Verify")} onClick={(e) => SendNotificationTo(e.target.checked, "First Verify")} />} label="FIRST, Verify" />
                            <FormControlLabel value={"Vendor"} control={<Checkbox disabled={setupType != 3} checked={SendNotifocation.includes("Vendor")} onClick={(e) => SendNotificationTo(e.target.checked, "Vendor")} />} label="Vendor" />
                            <FormControlLabel value={"Client"} control={<Checkbox checked={SendNotifocation.includes("Client")} onClick={(e) => SendNotificationTo(e.target.checked, "Client")} />} label="Client" />
                            <FormControlLabel value={"Site Contacts"} control={<Checkbox checked={SendNotifocation.includes("Site Contacts")} onClick={(e) => SendNotificationTo(e.target.checked, "Site Contacts")} />} label="Site Contacts" />
                        </FormControl>

                    </div>
                    <div className='mt-2'>
                        <span style={{ color: "#3E4A62", fontSize: "20px" }}>Email Template (if any)</span>
                        <br />

                        <FormControl>
                            <RadioGroup
                                aria-labelledby="demo-radio-buttons-group-label"
                                defaultValue="1"
                                name="radio-buttons-group"
                                value={emailTemplate}
                                onChange={(event) => setEmailTemplate(event.target.value)}
                            >
                                <FormControlLabel value={0} control={<Radio />} label="No Template" />
                                <FormControlLabel value={1} control={<Radio />} label="Predefined" />
                            </RadioGroup>
                        </FormControl>

                    </div>
                    <div className='mt-2' hidden={emailTemplate == 0}>
                        <Select
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                                width: "320px"
                            }}
                            labelId="demo-multiple-name-label"
                            id="demo-multiple-name"
                            size="small"
                            value={emailId || ""}
                            onChange={(e) => setEmailId(e.target.value)}
                            MenuProps={MenuProps}
                        >
                            {EmailList?.map((r, i) =>
                                <MenuItem key={i} value={r?.value} title={r?.text}>{r?.text}</MenuItem>)
                            }
                        </Select>

                    </div>


                </div>
            }
            <DialogActions >
                <div className="login-help__buttonContainer mt-4">
                    <Button variant="contained" className="login-help-button-cancel mx-2" onClick={CLOSE}>Cancel</Button>
                    <Button variant="contained" disabled={Dis} className="login-button-request mx-2" onClick={SaveorDeleteNotifications}>{ID == 3 ? "Ok" : ID == 1 ? "Add " : "Save"}</Button>
                </div>
            </DialogActions>
        </div >


    )
}
